<template>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>
